export default "__VITE_ASSET__CrT5GruR__"